var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.359.25-12.67 12.8H0V.25h25.359zm-2.091.872H.871v11.055h11.453L23.268 1.122zM4.784 3.65c.7 0 1.556.194 2.176.5l-.67 1.13c-.676-.318-1.017-.349-1.402-.368-.576-.03-.866.17-.87.386-.005.261.542.5 1.06.662.784.242 1.78.565 1.932 1.5l1.432-3.71h1.663l1.677 4.437V3.749h1.92c1.835 0 2.698.637 2.698 2.023 0 1.245-.889 1.987-2.388 1.987h-.62v1.792H10.55l-.284-.857a3.37 3.37 0 0 1-1 .15 3.34 3.34 0 0 1-1.025-.157l-.292.864H6.204l.191-.499-.069.057c-.435.34-.98.528-1.652.54l-.1.001A4.53 4.53 0 0 1 2.4 9.087l.593-1.145c.642.369 1.046.451 1.59.442.282-.007.486-.057.618-.19a.418.418 0 0 0 .126-.29c.006-.3-.43-.439-.962-.6-.433-.13-.922-.307-1.305-.58-.454-.324-.67-.73-.66-1.303a1.55 1.55 0 0 1 .46-1.089c.422-.425 1.103-.682 1.92-.682zM9.27 5.576h-.01l-.61 1.867c.182.067.392.106.615.106.219 0 .423-.037.602-.1L9.27 5.576zm4.546-.606h-.423v1.505h.423c.563 0 1.013-.181 1.013-.76 0-.563-.45-.745-1.013-.745z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.41333eaefb8a2fc4a533937113970e59.svg";
export { ForwardRef as ReactComponent };